export const enum Service {
  VIDEO_SERVICES = 'video_services',
  IMAGE_PROCESSING = 'image_processing',
  FLOORPLAN_SERVICS = 'floorplan_services',
  THREE_DIMENTIONAL_SERVICES = '3d_services'
}
